// The widget builds several URLs (booking API, JS-error log, policy links).
// Derive their host from the <script id="booking-widget"> embed tag so the same
// bundle follows whatever domain it was loaded from (book.zenagenda.com,
// book.ontimeagenda.com, ...) instead of hardcoding one. Mirrors how the main
// /api/booking/widget call already resolves its base URL.

export function bwBaseOrigin() {
    try {
        return new URL(document.getElementById('booking-widget').src).origin;
    } catch (e) {
        return 'https://book.zenagenda.com';
    }
}

export function bwMarketingBase() {
    try {
        var host = new URL(document.getElementById('booking-widget').src).hostname;
        return 'https://www.' + host.split('.').slice(-2).join('.');
    } catch (e) {
        return 'https://www.zenagenda.com';
    }
}
